<script setup lang="ts">
import { useDataStore } from '@/store/data';
import BaseAsset from './BaseAsset.vue';
import {
  PortfolioAsset,
  PortfolioAssetType,
  TokenInfo,
  getAddressFromAsset,
  getImageFromAssets,
  getLabelFromAssets,
} from '@sonarwatch/portfolio-core';
import { computed } from 'vue';
const props = defineProps<{
  assets: PortfolioAsset[];
  hideLabel?: boolean;
  label?: string;
}>();
const store = useDataStore();

const tokenInfos = computed(() => {
  const tokenInfos: Record<string, TokenInfo> = {};
  props.assets.forEach((asset) => {
    const tokenInfo = store.getTokenInfo(
      getAddressFromAsset(asset),
      asset.networkId,
    );
    if (tokenInfo) tokenInfos[tokenInfo.address] = tokenInfo;
  });
  return tokenInfos;
});
const images = computed(() =>
  getImageFromAssets(props.assets, tokenInfos.value),
);
const label = computed(() =>
  props.label
    ? props.label
    : getLabelFromAssets(props.assets, tokenInfos.value),
);
const textToCopy = computed(() => {
  if (props.assets.length !== 1) return undefined;
  const asset = props.assets.at(0) as PortfolioAsset;
  if (asset.type !== PortfolioAssetType.token) return undefined;
  return asset.data.address;
});
</script>

<template>
  <BaseAsset
    :images="images"
    :hide-label="hideLabel"
    :label="label"
    :text-to-copy="textToCopy"
  />
</template>
